import { render } from "./CustomerIndex.vue?vue&type=template&id=79b80d5a&scoped=true"
import script from "./CustomerIndex.vue?vue&type=script&lang=js"
export * from "./CustomerIndex.vue?vue&type=script&lang=js"

import "./CustomerIndex.vue?vue&type=style&index=0&id=79b80d5a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79b80d5a"]])

export default __exports__